import { render, staticRenderFns } from "./chatDoctor.vue?vue&type=template&id=e1933262&scoped=true&"
import script from "./chatDoctor.vue?vue&type=script&lang=js&"
export * from "./chatDoctor.vue?vue&type=script&lang=js&"
import style0 from "./chatDoctor.vue?vue&type=style&index=0&id=e1933262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1933262",
  null
  
)

export default component.exports